import { render, staticRenderFns } from "./profiles.vue?vue&type=template&id=7d156beb&scoped=true&"
import script from "./profiles.vue?vue&type=script&lang=js&"
export * from "./profiles.vue?vue&type=script&lang=js&"
import style0 from "./profiles.vue?vue&type=style&index=0&id=7d156beb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d156beb",
  null
  
)

export default component.exports